module.exports = __webpack_public_path__ + "img/payment-method.62a39957.svg";